import React from 'react';
import styles from './ClickableSquare.module.css';
import { NavLink } from 'react-router-dom';

const ClickableSquare = ({ text, icon, link }) => {
  return (
    <NavLink to={link} className={styles.clickableSquare}>
      <div className={styles.text}>{text}</div>
      <hr className={styles.line} />
      <div className={styles.iconCover}>
        <div className={styles.icon}>{icon}</div>
      </div>
    </NavLink>
  );
};

export default ClickableSquare;